import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { LOGO_URL } from "../constants/brand";
import { SecurityBadge } from "../components/shared/SecurityBadge";
import { PageWatermark } from "../components/shared/PageWatermark";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      setMessage("Password reset successful. You can now log in.");
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen bg-auth-bg flex items-center justify-center p-6 relative overflow-hidden">
      <PageWatermark variant="auth" />
      <div className="w-full max-w-md bg-auth-surface border border-auth-gold/15 p-10 relative z-[1]" data-testid="reset-password-card">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Iron Gate Consulting" className="w-24 h-24 object-contain mb-4 auth-glow" />
          <h1 className="font-serif text-xl text-auth-cream">Reset Password</h1>
        </div>
        {message ? (
          <div className="text-center">
            <p className="text-auth-success text-sm mb-4" data-testid="reset-password-success">{message}</p>
            <Link to="/login" className="text-auth-gold hover:text-auth-goldHover text-sm">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="reset-password-form">
            <Input
              data-testid="reset-new-password-input"
              type="password"
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New password"
              title="Choose your new password — this replaces your old one immediately once saved."
              className="bg-auth-surfaceLight border-auth-gold/20 text-auth-cream h-12"
            />
            {error && <p className="text-auth-danger text-sm" data-testid="reset-password-error">{error}</p>}
            <Button data-testid="reset-password-submit-button" type="submit" title="Saves this new password to your account." className="w-full h-12 bg-auth-gold hover:bg-auth-goldHover text-black">
              Reset Password
            </Button>
            <SecurityBadge variant="login" />
          </form>
        )}
      </div>
    </div>
  );
}
